import React, { useState } from "react";
import { graphql } from "gatsby";

import Hero from "../components/hero";
import ContentBlocks from "../components/contentBlocks";
import LookUpWidget from "../components/lookUpWidget";
import InfoRows from "../components/InfoRows";
import IconContent from "../components/iconContent";
import DownloadBanner from "../components/downloadBanner";
import LatestListing from "../components/latestListing";
import StepSlider from "../components/stepSlider";
import InverseSlider from "../components/inverseSlider";
import TipsAndAdviceWidget from "../components/tipsAndAdviceWidget";
import ReviewsWidget from "../components/reviewsWidget";
import ContactForm from "../components/contactForm";
import Infographic from "../components/infographic";
import FeatureSlider from "../components/featureSlider";
import CTAColumns from "../components/cta-columns";
import TwoColCta from "../components/twoColCta";
import WhyChooseUs from "../components/whyChooseUs";
import HomeHero from "../components/homeHero";
import HomeMatchHero from "../components/homeMatchHero";
import WhyHomestaHero from "../components/whyHomestaHero";
import BlogHero from "../components/blogHero";
import BlogList from "../components/blogList";
import SellHero from "../components/sellHero";
import ContactHero from "../components/contactHero";
import CTA from "../components/cta";
import Pricing from "../components/pricing";
import TwoColTile from "../components/twoColTile";
import TwoColumnTileLarge from "../components/twoColumnTileLarge";
import FullWidthBanner from "../components/fullWidthBanner";
import TextBanner from "../components/textBanner";
import ThreeColumnTileWithIcon from "../components/threeColumnTileWithIcon";
import ThreeColumnTile from "../components/threeColumnTile";
import FourColumnTiles from "../components/fourColumnTiles";
import JoinTheMovementSection from "../components/joinTheMovementSection";
import TwoColumnSection from "../components/twoColumnSection";
import HowItWorks from "../components/howItWorks";
import Accordion from "../components/accordion";
import Tabs from "../components/tabs";
import PropertyDetails from "../components/propertyDetails";
import { TopWave, BottomWave } from "../components/wave";

import HtmlPane from "../components/htmlpane";

import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import Layout from "../containers/layout";
// import ThreeColumnWithIcon from "../../../studio/schemas/plugs/threeColumnWithIcon";

export const query = graphql`
  query PageTemplateQuery($id: String!) {
    route: sanityRoute(id: { eq: $id }) {
      slug {
        current
      }
      useSiteTitle
      page {
        ...PageInfo
      }
    }
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      primaryColor {
        hex
      }
      secondaryColor {
        hex
      }
      title
      openGraph {
        title
        description
        image {
          ...SanityImage
        }
      }
      footerMenu {
        ...NavMenu
      }
      footerMenuCol1 {
        title
        ...NavMenu
      }
      footerMenuCol2 {
        title
        ...NavMenu
      }
      footerMenuCol3 {
        title
        ...NavMenu
      }
    }
  }
`;

const Page = props => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    );
  }

  const page = data.page || data.route.page;

  const content = (page._rawContent || [])
    .filter(c => !c.disabled)
    .map((c, i) => {
      let el = null;
      switch (c._type) {
        case "html":
          el = <HtmlPane key={c._key} {...c} />;
          break;
        case "pricing":
          el = <Pricing key={c._key} {...c} />;
          break;
        case "infoRows":
          el = <InfoRows key={c._key} {...c} />;
          break;
        case "hero":
          el = <Hero key={c._key} {...c} />;
          break;
        case "iconContent":
          el = <IconContent key={c._key} {...c} />;
          break;
        case "downloadBanner":
          el = <DownloadBanner key={c._key} {...c} />;
          break;
        case "latestListing":
          el = <LatestListing key={c._key} {...c} />;
          break;
        case "stepSlider":
          el = <StepSlider key={c._key} {...c} />;
          break;
        case "inverseSlider":
          el = <InverseSlider key={c._key} {...c} />;
          break;
        case "tipsAndAdviceWidget":
          el = <TipsAndAdviceWidget key={c._key} {...c} />;
          break;
        case "reviewsWidget":
          el = <ReviewsWidget key={c._key} {...c} />;
          break;
        case "contentBlocks":
          el = <ContentBlocks key={c._key} {...c} />;
          break;
        case "contactForm":
          el = <ContactForm key={c._key} {...c} />;
          break;
        case "infographic":
          el = <Infographic key={c._key} {...c} />;
          break;
        case "twoColCta":
          el = <TwoColCta key={c._key} {...c} />;
          break;
        case "whyChooseUs":
          el = <WhyChooseUs key={c._key} {...c} />;
          break;
        case "lookUpWidget":
          el = <LookUpWidget key={c._key} {...c} />;
          break;
        case "homeHero":
          el = <HomeHero key={c._key} {...c} />;
          break;
        case "homeMatchHero":
          el = <HomeMatchHero key={c._key} {...c} />;
          break;
        case "blogHero":
          el = <BlogHero key={c._key} {...c} />;
          break;
        case "blogList":
          el = <BlogList key={c._key} {...c} />;
          break;
        case "sellHero":
          el = <SellHero key={c._key} {...c} />;
          break;
        case "contactHero":
          el = <ContactHero key={c._key} {...c} />;
          break;
        case "whyHomestaHero":
          el = <WhyHomestaHero key={c._key} {...c} />;
          break;
        case "featuresSlider":
          el = <FeatureSlider key={c._key} {...c} />;
          break;
        case "ctaColumns":
          el = <CTAColumns key={c._key} {...c} />;
          break;
        case "ctaPlug":
          el = <CTA key={c._key} {...c} />;
          break;
        case "twoColTile":
          el = <TwoColTile key={c._key} {...c} />;
          break;
        case "twoColumnTileLarge":
          el = <TwoColumnTileLarge key={c._key} {...c} />;
          break;
        case "fullWidthBanner":
          el = <FullWidthBanner key={c._key} {...c} />;
          break;
        case "textBanner":
          el = <TextBanner key={c._key} {...c} />;
          break;
        case "threeColumnTileWithIcon":
          el = <ThreeColumnTileWithIcon key={c._key} {...c} />;
          break;
        case "threeColumnTile":
          el = <ThreeColumnTile key={c._key} {...c} />;
          break;
        case "fourColumnTiles":
          el = <FourColumnTiles key={c._key} {...c} />;
          break;
        case "joinTheMovementSection":
          el = <JoinTheMovementSection key={c._key} {...c} />;
          break;
        case "twoColumnSection":
          el = <TwoColumnSection key={c._key} {...c} />;
          break;
        case "howItWorks":
          el = <HowItWorks key={c._key} {...c} />;
          break;
        case "accordion":
          el = <Accordion key={c._key} {...c} />;
          break;
        case "tabs":
          el = <Tabs key={c._key} {...c} />;
          break;
        case "propertyDetails":
          el = <PropertyDetails key={c._key} {...c} />;
          break;
        case "uiComponentRef":
          switch (c.name) {
            case "topWave":
              el = <TopWave />;
              break;
            case "bottomWave":
              el = <BottomWave />;
              break;
            default:
              break;
          }
          break;
        default:
          el = null;
      }
      return el;
    });

  const gradient = {
    from: (site.primaryColor && site.primaryColor.hex) || "#d53369",
    to: (site.secondaryColor && site.secondaryColor.hex) || "#daae51"
  };

  const menuItems = page.navMenu && (page.navMenu.items || []);
  const footerMenuItems = site.footerMenu && (site.footerMenu.items || []);
  const footerMenuCol1 = site.footerMenuCol1;
  const footerMenuCol2 = site.footerMenuCol2;
  const footerMenuCol3 = site.footerMenuCol3;
  const pageTitle = data.route && !data.route.useSiteTitle && page.title;

  return (
    <Layout navMenuItems={menuItems} footerMenuItems={footerMenuItems} textWhite={true} footerMenuCol1={footerMenuCol1} footerMenuCol2={footerMenuCol2} footerMenuCol3={footerMenuCol3}>
      <SEO
        title={pageTitle}
        description={site.description}
        keywords={site.keywords}
        bodyAttr={{
          class: "leading-normal tracking-normal"
        }}
        gradient={gradient}
      />
      <div className="pt-24">{content}</div>
    </Layout>
  );
};

export default Page;
